import React from 'react';
import { i18n } from 'utils/i18n';
import Modal from 'components/Modal';
import MODAL, { MODAL_THEMES } from 'constants/modals';
import EditModalContent from 'components/ReservationFlow/Review/EditModalContent';

const PrepayEditModal = ({ onPaymentModalClose, handleEdit }) => (
  <Modal
    modalKey={MODAL.PREPAY_EDIT_MODAL}
    header={i18n('prepayment_edit_modal_header')}
    theme={MODAL_THEMES.WHITE}
    onClose={onPaymentModalClose}
  >
    {({ sectionPath }) => (
      <EditModalContent
        describedByID={`${MODAL.PREPAY_EDIT_MODAL}_desc`}
        handleEdit={handleEdit}
        sectionPath={sectionPath}
      />
    )}
  </Modal>
);

export default PrepayEditModal;
